import { useConvexAuth } from 'convex/react';
import { Outlet, useLocation } from 'react-router-dom';
import { useWorkOSAuth } from '../lib/auth';
import { appRoutes, storeAuthReturnTo } from '../lib/routes';
import { FullScreenLoader } from './ui/feedback';

/** Route layout for `/app/*`: renders nested routes only for users authenticated in WorkOS and Convex. */
export function ProtectedRoute() {
  const { user, signIn, isLoading: authLoading } = useWorkOSAuth();
  const { isLoading: convexLoading, isAuthenticated } = useConvexAuth();
  const location = useLocation();

  if (authLoading || convexLoading) {
    return <FullScreenLoader />;
  }

  if (!user || !isAuthenticated) {
    const returnTo = location.pathname + location.search + location.hash;
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-logo">
            <span>V</span>
          </div>

          <h1 className="auth-title">Anmeldung erforderlich</h1>
          <p className="auth-subtitle">Bitte melden Sie sich an, um diesen Bereich zu nutzen.</p>

          <div className="auth-buttons">
            <button
              type="button"
              onClick={() => {
                storeAuthReturnTo(returnTo);
                void signIn({ state: { returnTo: returnTo || appRoutes.dashboard } });
              }}
              className="btn btn-primary btn-lg w-full"
            >
              Anmelden
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
